// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"f2129d30","392":"129cab72","428":"c13a1eff","643":"547dfec2","791":"3e74c41c","800":"4a64a2af","857":"ba2c8939"}[chunkId] + ".chunk.js";
};